import editionCerfa from '@/api/editionCerfa/index';
import { TYPE_EDITION_COMMANDE_R_TLPE } from '@/configuration/gabed/tlpe/tlpeConf';

export default async function editionCerfaAsync(commandesId, lien) {
  const response = await editionCerfa({
    ids: commandesId,
    typeDonnee: TYPE_EDITION_COMMANDE_R_TLPE,
  });
  const link = lien;
  link.href = window.URL.createObjectURL(response.data);
  const disposition = response.request.getResponseHeader('Content-Disposition');
  link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
  link.click();
}
